import { render, staticRenderFns } from "./newCampaign.vue?vue&type=template&id=54fb5274&scoped=true"
import script from "./newCampaign.vue?vue&type=script&lang=js"
export * from "./newCampaign.vue?vue&type=script&lang=js"
import style0 from "./newCampaign.vue?vue&type=style&index=0&id=54fb5274&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fb5274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54fb5274')) {
      api.createRecord('54fb5274', component.options)
    } else {
      api.reload('54fb5274', component.options)
    }
    module.hot.accept("./newCampaign.vue?vue&type=template&id=54fb5274&scoped=true", function () {
      api.rerender('54fb5274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/fpaManage/fpaLtoCampaign/newCampaign.vue"
export default component.exports